import { useNavigate } from 'react-router-dom';
import { useCallback, useState } from 'react';
import { titleRepositorySingleton } from '@warehouse/title/infra';
import { useSnackbar } from 'notistack';

export function useImportMEC() {
	const navigate = useNavigate();
	const [loading, setLoading] = useState(false);
	const [importErrors, setImportErrors] = useState<string[]>([]);
	const { enqueueSnackbar } = useSnackbar();

	const titleRepo = titleRepositorySingleton.get();

	const importMEC = useCallback(
		async (mec: string) => {
			setLoading(true);
			try {
				const title = await titleRepo.importMEC(mec);
				enqueueSnackbar('Imported successfully', { variant: 'success' });
				navigate(`/title/${title.uuid}`);
			} catch (err: any) {
				const Errors = err?.graphQLErrors?.[0]?.extensions?.errors;
				const errorList =
					Array.isArray(Errors) && Errors.length > 0 ? Errors : [err?.message || 'Failed to import MEC file'];
				setImportErrors(errorList);
			} finally {
				setLoading(false);
			}
		},
		[navigate, titleRepo, enqueueSnackbar],
	);
	const clearErrors = useCallback(() => {
		setImportErrors([]);
	}, []);

	return { importMEC, loading, errors: importErrors, clearErrors };
}
